import { Box, CircularProgress, Typography } from '@mui/material';

import './LoadingSpinner.css';


interface ILoadingSpinnerProps {
  message?: string;
}

function LoadingSpinner({ message = 'Authenticating...' }: ILoadingSpinnerProps){
    return (
        <Box className="spinner-container">
            <CircularProgress />

            <Typography variant="body1" className="spinner-message">
                {message}
            </Typography>
        </Box>
    );
};

export default LoadingSpinner;